import template from './sharedmoments.html'
import controller from './sharedmoments.controller'
import './sharedmoments.scss'
import './sharedmoments.mobile.scss'

const sharedmomentsComponent = {
    bindings: {
        data: '@'
    },
    template,
    controller
}

export default sharedmomentsComponent



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/sharedmoments.component.js